import {
  getModules,
  getModulesChildren,
  getRoles,
  patchPermissionStatus,
  patchRoleObjects,
  saveOrResetPermissions
} from "@/api/administration"

export default {
  getPermissionRoles({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      getRoles(params).then(response => {
        resolve(response.data)
        commit('SET_ROLE_LIST', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getPermissionModule({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      getModules(params).then(response => {
        resolve(response.data)
        commit('SET_MODULE_LIST', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getPermissionModuleChildren({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      getModulesChildren(params).then(response => {
        resolve(response.data)
        commit('SET_MODULE_LIST_CHILDREN', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  updateRoleObject(_, data) {
    return patchRoleObjects(data)
  },

  updatePermissionStatus(_, data) {
    return patchPermissionStatus(data)
  },

  saveOrReset(_, data) {
    return saveOrResetPermissions(data)
  },
}